import { Button } from '@analytical-alley/ui';
import React from 'react';

export function Footer({dirty, onClick, loading}: {
    dirty: boolean;
    onClick: () => void;
    loading: boolean;
}) {
    const tooltipMessage = dirty ?
        'Find the best channel budgets according to the values you set.' :
        'Everything is up to date';

    return (
        <div className="flex justify-center gap-4 items-center px-6 py-4 ">
            <Button
                color={dirty ? 'blue' : 'glass'}
                size="lg"
                onClick={onClick}
                disabled={!dirty || loading}
                tooltip={tooltipMessage}
            >
                {loading ? 'Optimizing...' : 'Run Optimization'}
            </Button>
        </div>
    );
}
